import React from "react";
import {
  dateColumn,
  moneyColumn,
  gstTypeColumn,
  itemCountColumn,
  paymentStatusColumn,
  companyColumn
} from "../../../shared/components/tableColumns.jsx";

const isNonGstPurchase = (p) => p.billType === "Normal" || p.isNonGst;

/** Desktop table columns for the Purchases list (cards stay the phone layout). */
export function purchaseColumns({ defaultCompany, showCompany }) {
  return [
    dateColumn("billDate", "Date", (p) => p.companyDetails?.dateFormat || defaultCompany?.dateFormat),
    { key: "vendorBillNo", label: "Bill #", width: 130, render: (p) => <strong>{p.vendorBillNo || "No Bill #"}</strong> },
    gstTypeColumn(isNonGstPurchase),
    { key: "vendorName", label: "Vendor" },
    ...(showCompany ? [companyColumn((p) => p.companyName)] : []),
    itemCountColumn,
    moneyColumn("grandTotal", "Amount"),
    moneyColumn("balance", "To Pay", { dashWhenZero: true }),
    paymentStatusColumn
  ];
}
